
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Vimannagartomumbaicabs() {



    const cardData =
    {
        keyword: ' Viman Nagar to Mumbai Cabs',
        heading: 'Prince Cabs: Viman Nagar to Mumbai Cabs',
        headingDescription: 'Prince Cabs offers reliable Viman Nagar to Mumbai Cabs, perfect for airport transfers, corporate travel, family trips, and outstation journeys. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a safe, comfortable, and convenient ride from Viman Nagar to Mumbai via the expressway. With professional chauffeurs, on-time pickups, and transparent fares, we make your travel completely hassle-free. Choose Prince Cabs’ trusted cab service from Viman Nagar to Mumbai for comfort, affordability, and reliability.',

        top: 'Top Places to Visit in Mumbai with Prince Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s most iconic landmark overlooking the Arabian Sea. Constructed in Indo-Saracenic style, it commemorates the visit of King George V and Queen Mary. The site is a bustling hub with tourists, photographers, and ferry rides to Elephanta Caves. At sunset, the arch glows beautifully against the skyline. It remains the proud symbol of South Mumbai. Gateway of India is the city’s historic and cultural centerpiece."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen’s Necklace, is a 3.6 km crescent-shaped boulevard along the Arabian Sea. Locals and tourists flock here for evening walks, sea breezes, and stunning sunsets. At night, its streetlights resemble a sparkling necklace. During monsoon, waves dramatically crash against the promenade. It reflects the modern, vibrant spirit of Mumbai. Marine Drive is the heart of the city’s leisure life."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "CST, formerly Victoria Terminus, is a UNESCO World Heritage railway station built in 1887. Its Gothic Revival architecture features domes, spires, stained glass windows, and intricate carvings. The building looks spectacular when illuminated at night. It is both a functional transport hub and a heritage monument. Tourists admire its grandeur while witnessing Mumbai’s lifeline—the local trains. CST symbolizes Mumbai’s blend of history and modernity."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves, located on Elephanta Island, are UNESCO-listed rock-cut temples dating to the 5th–6th centuries. The highlight is the magnificent Trimurti sculpture of Lord Shiva. The caves reflect India’s ancient artistry and spiritual traditions. Accessible by ferry from Gateway of India, the island offers peace away from the city. Lush greenery surrounds the caves, enhancing their charm. It is a must-visit for history and culture lovers."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most famous beach, popular for street food and leisure walks. Vendors serve local delights like pav bhaji, bhel puri, and ice gola. Families gather in the evenings to enjoy the sea breeze and sunset. Bollywood celebrities residing nearby make it a star-spotting zone. The beach is lively with children playing and locals exercising. Juhu Beach is Mumbai’s vibrant coastal escape."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most visited shrines, dedicated to Lord Ganesha. Built in 1801, it attracts devotees, celebrities, and politicians daily. The golden dome and beautifully carved wooden doors add grandeur. Tuesdays are especially crowded with worshippers. Devotees believe wishes made here are fulfilled. Siddhivinayak Temple is the spiritual core of Mumbai."
  },
  {
    "title": "Bandra–Worli Sea Link",
    "description": "The Bandra–Worli Sea Link is an eight-lane cable-stayed bridge and an engineering marvel. It connects South Mumbai with the western suburbs, reducing travel time significantly. The bridge offers stunning views of the Arabian Sea and skyline. At night, its illuminated structure looks spectacular. Driving across the Sea Link is a thrilling experience. It is a modern symbol of Mumbai’s progress."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, built in the 15th century, is a revered shrine located on an islet in the Arabian Sea. Dedicated to Pir Haji Ali Shah Bukhari, it is a blend of spirituality and architecture. The dargah is connected by a causeway accessible at low tide. Devotees from all religions visit to seek blessings. Its sea-facing setting creates a serene atmosphere. Haji Ali is Mumbai’s iconic spiritual landmark."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is Mumbai’s bustling street market and shopping paradise. Visitors shop for clothes, handicrafts, jewelry, and antiques at bargain prices. Iconic cafés like Leopold Café and Café Mondegar add to the charm. The area is always lively with both locals and tourists. Bargaining with street vendors is part of the fun. Colaba Causeway is the ultimate shopping and cultural hotspot of Mumbai."
  },
  {
    "title": "Girgaon Chowpatty",
    "description": "Girgaon Chowpatty is a lively beach in South Mumbai, famous for Ganesh Visarjan celebrations. Families and couples enjoy snacks like pav bhaji, kulfi, and bhel here. The beach is vibrant during evenings and festivals. It offers views of Marine Drive’s arc and the Arabian Sea. Children love playing in the sand and waves. Girgaon Chowpatty is Mumbai’s blend of tradition and leisure."
  },
  {
    "title": "Film City, Goregaon",
    "description": "Film City in Goregaon is the hub of Bollywood filmmaking, spread over 500 acres. It has studios, artificial sets, and shooting zones for films and TV shows. Guided tours take visitors behind the scenes of movie production. Cinema lovers enjoy spotting live shoots. It is one of the largest film complexes in the world. Film City showcases Mumbai’s entertainment identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "Sanjay Gandhi National Park is a vast green sanctuary within Mumbai, covering 87 sq. km. It is home to leopards, deer, and hundreds of bird species. Inside the park, the Kanheri Caves display Buddhist stupas and rock-cut monasteries dating back to the 1st century BC. Visitors enjoy safaris, toy train rides, and treks. It is rare to find such nature in a metro. This park blends history, wildlife, and adventure."
  },
  {
    "title": "Powai Lake",
    "description": "Powai Lake is an artificial lake surrounded by greenery and skyscrapers. It is popular among birdwatchers, with species like herons and kingfishers often spotted. Joggers and photographers enjoy its promenade. During monsoon, the lake looks especially scenic with misty surroundings. It is a peaceful retreat within the bustling city. Powai Lake is Mumbai’s hidden natural gem."
  },
  {
    "title": "Global Vipassana Pagoda",
    "description": "The Global Vipassana Pagoda near Gorai is one of the world’s largest meditation domes. Built in Burmese architectural style, it houses relics of Buddha. The golden dome accommodates thousands of meditators. Visitors attend meditation sessions and admire the grand design. Its seaside setting enhances tranquility. The pagoda symbolizes peace, spirituality, and harmony."
  },
  {
    "title": "Nehru Planetarium & Science Centre",
    "description": "Nehru Planetarium in Worli is an educational hub for astronomy enthusiasts. Sky shows inside its dome theatre explain stars, galaxies, and cosmic wonders. The adjoining Science Centre offers interactive exhibits on innovation and technology. Families and students find it educational yet entertaining. Special events are held during eclipses and celestial events. It is Mumbai’s hub of science and curiosity."
  }
],

"services": [
  {
    "name": "Viman Nagar to Mumbai Cab Booking",
    "description": "Book reliable cab services from Viman Nagar to Mumbai with instant confirmation and flexible scheduling. Whether you're heading for business, leisure, or catching a flight, our cab booking ensures timely pickups, clean vehicles, and trained drivers for a seamless travel experience."
  },
  {
    "name": "Viman Nagar to Mumbai Innova Cab",
    "description": "Travel in comfort from Viman Nagar to Mumbai with our spacious Innova cabs. Ideal for families and groups, the Toyota Innova offers superior legroom, luggage space, and smooth rides—perfect for long-distance journeys across cities."
  },
  {
    "name": "Viman Nagar to Mumbai Dzire Taxi",
    "description": "Hire a budget-friendly Swift Dzire taxi from Viman Nagar to Mumbai for a convenient and economical travel solution. Suitable for individuals or small families, our Dzire taxis offer AC, comfortable seating, and punctual service."
  },
  {
    "name": "Viman Nagar to Mumbai One Way Cab",
    "description": "Book a one-way cab from Viman Nagar to Mumbai for flexible and affordable intercity travel. Our one-way service is ideal for travelers not planning a return trip, and includes multiple car options, transparent pricing, and professional drivers."
  },
  {
    "name": "Viman Nagar to Mumbai Airport Taxi",
    "description": "Ensure a stress-free airport transfer with our Viman Nagar to Mumbai Airport taxi service. Enjoy door-to-door pickup, luggage assistance, and timely arrivals in well-maintained vehicles suited for all types of travelers."
  },
  {
    "name": "Viman Nagar to Mumbai Round Trip Taxi",
    "description": "Plan your round trip from Viman Nagar to Mumbai with ease using our cab service. Enjoy the convenience of keeping your cab for return, with flexible wait times, reliable drivers, and comfortable vehicles for both journeys."
  },
  {
    "name": "Viman Nagar to Mumbai Ertiga Cab",
    "description": "Hire a 6–7 seater Ertiga cab from Viman Nagar to Mumbai for a comfortable family or group trip. The Ertiga combines fuel efficiency with space and comfort, making it a top choice for outstation travel with moderate luggage."
  },
  {
    "name": "Viman Nagar to Mumbai Swift Cab",
    "description": "Choose a Swift cab from Viman Nagar to Mumbai for quick, safe, and affordable intercity travel. Swift cabs are perfect for solo travelers or couples seeking a fast and economical transport option with AC comfort."
  },
  {
    "name": "Viman Nagar to Mumbai Crysta Cab",
    "description": "Experience premium travel from Viman Nagar to Mumbai with our Innova Crysta cab service. The Crysta offers plush interiors, great suspension, and extra luggage space—ideal for long trips, business travel, or VIP transfers."
  },
  {
    "name": "Affordable Cab Viman Nagar to Mumbai",
    "description": "Looking for a low-cost travel solution? Our affordable cabs from Viman Nagar to Mumbai offer clean vehicles, courteous drivers, and fixed pricing—ensuring you get maximum value without compromising comfort or reliability."
  },
  {
    "name": "Viman Nagar to Mumbai Sedan Taxi",
    "description": "Book a sedan taxi from Viman Nagar to Mumbai for comfortable rides at a reasonable cost. With AC, spacious seats, and professional drivers, sedans like Dzire or Etios are ideal for individuals and small families."
  },
  {
    "name": "Viman Nagar to Mumbai Outstation Cab",
    "description": "Our Viman Nagar to Mumbai outstation cab service provides the best solution for long-distance travel with experienced drivers and vehicle options tailored for safety, comfort, and convenience. Ideal for one-way, round trip, or multi-city journeys."
  },
  {
    "name": "Viman Nagar to Mumbai Tempo Traveller",
    "description": "Travel with larger groups from Viman Nagar to Mumbai in a 7–13 seater Tempo Traveller. This service offers spacious interiors, ample legroom, and AC comfort—making it perfect for corporate travel, weddings, or family vacations."
  },
  {
    "name": "AC Cab Viman Nagar to Mumbai",
    "description": "Beat the heat and enjoy cool comfort in our AC cab service from Viman Nagar to Mumbai. Choose from a range of AC vehicles including sedans, SUVs, and MPVs—all driven by professionals for a smooth intercity trip."
  },
  {
    "name": "Viman Nagar to Mumbai Family Taxi",
    "description": "Book a reliable family taxi from Viman Nagar to Mumbai with vehicles like Ertiga or Innova, offering space, safety, and comfort. Ideal for holiday trips, weekend getaways, or visiting relatives in Mumbai."
  }
],
"tableData": [
  ["Viman Nagar to Mumbai Cab Booking", "Viman Nagar to Mumbai Innova Cab"],
  ["Viman Nagar to Mumbai Dzire Taxi", "Viman Nagar to Mumbai One Way Cab"],
  ["Viman Nagar to Mumbai Airport Taxi", "Viman Nagar to Mumbai Round Trip Taxi"],
  ["Viman Nagar to Mumbai Ertiga Cab", "Viman Nagar to Mumbai Swift Cab"],
  ["Viman Nagar to Mumbai Crysta Cab", "Affordable Cab Viman Nagar to Mumbai"],
  ["Viman Nagar to Mumbai Sedan Taxi", "Viman Nagar to Mumbai Outstation Cab"],
  ["Viman Nagar to Mumbai Tempo Traveller", "AC Cab Viman Nagar to Mumbai"],
  ["Viman Nagar to Mumbai Family Taxi"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Viman Nagar to Mumbai Cab Service",
    "WhyChoosedescription": "Prince Cabs provides dependable and on-time cab services from Viman Nagar, Pune to various locations in Mumbai including South Mumbai, suburbs, or Mumbai International Airport. Located close to Pune Airport and major IT parks, Viman Nagar is a popular pickup point for business travelers, tourists, and families heading to Mumbai. Our door-to-door cab service ensures a comfortable and safe transfer right from your doorstep."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Whether you're traveling solo or in a group, we offer a fleet of well-maintained vehicles that include economy sedans, spacious SUVs, and premium cars. Options like Swift Dzire, Honda Amaze, Innova Crysta, and Ertiga ensure you get the right vehicle based on your passenger count, luggage requirements, and comfort preferences. All vehicles come with AC, plush interiors, and safety features for a smooth and enjoyable journey."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "Our cab fare from Viman Nagar to Mumbai is fully transparent and competitively priced. The fare includes all major costs—fuel, tolls, driver allowance, and taxes—so there are no last-minute surprises. You can choose from one-way, round-trip, or customizable rental packages based on your travel schedule. Clear pricing helps you plan your journey with full confidence and control over your travel budget."
  },
  {
    "WhyChooseheading": "Flexible Booking via Phone, WhatsApp, or Online",
    "WhyChoosedescription": "Booking your cab from Viman Nagar to Mumbai is quick and hassle-free. Simply call us, drop a message on WhatsApp, or use our online booking portal. You'll receive instant confirmation along with driver and vehicle details. Need to make changes to your trip? Our flexible rescheduling and cancellation policies make the process smooth and customer-friendly."
  },
  {
    "WhyChooseheading": "Experienced and Courteous Drivers",
    "WhyChoosedescription": "Our drivers are punctual, professionally trained, and familiar with the Pune–Mumbai expressway and local traffic patterns. From helping with luggage to ensuring a safe and smooth ride, they go the extra mile to offer a comfortable travel experience. All drivers are background-verified and trained to maintain proper driving etiquette and cleanliness in the vehicle."
  },
  {
    "WhyChooseheading": "Clean, Sanitized & Well-Maintained Vehicles",
    "WhyChoosedescription": "Every cab is thoroughly cleaned and sanitized before each trip, especially important for pickups from busy areas like Viman Nagar. Our vehicles undergo regular servicing and are equipped with air-conditioning, clean upholstery, and safety essentials like seat belts and airbags—providing a secure and hygienic travel environment for all passengers."
  },
  {
    "WhyChooseheading": "24/7 Service and Customer Support",
    "WhyChoosedescription": "Prince Cabs operates round the clock to serve your travel needs anytime—from early morning airport drops to late-night city transfers. Our 24/7 customer support team is available to assist with booking, updates, emergency support, and any travel-related queries, ensuring a smooth experience from Viman Nagar to Mumbai."
  }
]
























    }

const faqData = [
    {
        question: 'Does Prince Cabs offer cab service from Viman Nagar to Mumbai?',
        answer: 'Yes, Prince Cabs provides reliable and comfortable cab service from Viman Nagar, Pune to Mumbai for one-way and round trips.',
    },
    {
        question: 'What types of cabs are available from Viman Nagar to Mumbai?',
        answer: 'We offer a range of vehicles including Swift Dzire, Ertiga, Innova, and Tempo Traveller to suit individual, family, or group travel needs.',
    },
    {
        question: 'How long does the journey take from Viman Nagar to Mumbai by cab?',
        answer: 'The travel time typically ranges from 3.5 to 4.5 hours depending on traffic and time of day.',
    },
    {
        question: 'Can I book a one-way cab from Viman Nagar to Mumbai?',
        answer: 'Absolutely! Prince Cabs specializes in both one-way and round-trip bookings as per your travel preferences.',
    },
    {
        question: 'Are the cabs from Viman Nagar to Mumbai sanitized and well-maintained?',
        answer: 'Yes, all cabs are regularly cleaned, sanitized, and serviced to ensure a safe and comfortable ride.',
    },
    {
        question: 'What are the cab fare charges from Viman Nagar to Mumbai?',
        answer: 'Cab fares depend on the vehicle type and distance. Contact Prince Cabs for an exact and competitive quote.',
    },
    {
        question: 'How do I book a cab from Viman Nagar to Mumbai?',
        answer: 'You can book through our website or call our customer support team to confirm your trip quickly and easily.',
    },
];

const testimonials = [
    {
        name: "Mr. Arjun Rane",
        position: "IT Professional",
        text: "I booked a cab from Viman Nagar to Mumbai with Prince Cabs. The service was excellent, the vehicle was clean, and the driver was courteous.",
        image: "/img/testimonial/testimonial-thumb-viman-mumbai-1.png",
    },
    {
        name: "Ms. Tanvi Kulkarni",
        position: "Frequent Traveler",
        text: "Prince Cabs made my journey from Viman Nagar to Mumbai seamless. Great pricing and timely pickup. Highly recommended!",
        image: "/img/testimonial/testimonial-thumb-viman-mumbai-2.png",
    },
];







































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Viman Nagar to Mumbai Cabs",
  "description": "Book reliable and affordable cabs from Viman Nagar to Mumbai including Innova Crysta, Dzire, Ertiga, Swift, Sedan, and Tempo Traveller. One-way, round trip, airport drop, and family travel options available.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Viman Nagar",
      "addressRegion": "Pune, Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Viman Nagar to Mumbai Cab Booking",
    "Viman Nagar to Mumbai Innova Cab",
    "Viman Nagar to Mumbai Dzire Taxi",
    "Viman Nagar to Mumbai One Way Cab",
    "Viman Nagar to Mumbai Airport Taxi",
    "Viman Nagar to Mumbai Round Trip Taxi",
    "Viman Nagar to Mumbai Ertiga Cab",
    "Viman Nagar to Mumbai Swift Cab",
    "Viman Nagar to Mumbai Crysta Cab",
    "Affordable Cab Viman Nagar to Mumbai",
    "Viman Nagar to Mumbai Sedan Taxi",
    "Viman Nagar to Mumbai Outstation Cab",
    "Viman Nagar to Mumbai Tempo Traveller",
    "AC Cab Viman Nagar to Mumbai",
    "Viman Nagar to Mumbai Family Taxi"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};




    return (
        <div>
<Helmet>
  <title>Viman Nagar to Mumbai Cab | Book Innova, Dzire, Tempo Traveller</title>
  <meta
    name="description"
    content="Affordable cab service from Viman Nagar to Mumbai. Book one-way or round trip in Innova Crysta, Dzire, Sedan, Ertiga, Tempo Traveller and more for airport drop or family travel."
  />
  <meta
    name="keywords"
    content="Viman Nagar to Mumbai Cab Booking, Viman Nagar to Mumbai Innova Cab, Viman Nagar to Mumbai Dzire Taxi, Viman Nagar to Mumbai One Way Cab, Viman Nagar to Mumbai Airport Taxi, Viman Nagar to Mumbai Round Trip Taxi, Viman Nagar to Mumbai Ertiga Cab, Viman Nagar to Mumbai Swift Cab, Viman Nagar to Mumbai Crysta Cab, Affordable Cab Viman Nagar to Mumbai, Viman Nagar to Mumbai Sedan Taxi, Viman Nagar to Mumbai Outstation Cab, Viman Nagar to Mumbai Tempo Traveller, AC Cab Viman Nagar to Mumbai, Viman Nagar to Mumbai Family Taxi"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/62.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Vimannagartomumbaicabs ;